jQuery(document).ready(function($) {

	// Lazy load
	$(function() {
        $('.img-load').lazy({
          effect: "fadeIn",
          effectTime: 250,
          threshold: 0
        });
    });

    // Product Sidebar //

    $('.product-item').mouseenter(function() {
    	var dataTitle = $(this).data('title');
    	$(".sub-menu").find("[data-title='" + dataTitle + "']").addClass('active').closest('.collection-item').find('.sub-header').addClass('active');
    });
    $('.product-item').mouseleave(function() {
    	var dataTitle = $(this).data('title');
    	$(".sub-menu").find("[data-title='" + dataTitle + "']").removeClass('active');
    	$('.sub-header').removeClass('active');
    });

    $('.collection-item').click(function() {
    	var dataTag = $(this).data('tag');
    	$(".collection-grid").find("[data-tag-1!='" + dataTag + "']").removeClass('active').addClass('fade');
    	$(".collection-grid").find("[data-tag-1='" + dataTag + "']").addClass('active').removeClass('fade');
    });

    var productTag = $('.product-page').data('title');
    $(".sub-menu").find("[data-title='" + productTag + "']").addClass('active').closest('.collection-item').find('.sub-header').addClass('active');

    $('.sub-header.menu-hide').next('.sub-menu').hide();

    $('.sub-header.active').next('.sub-menu').slideDown(250);

    $('.sub-header').click(function() {
    	$('.sub-header').not(this).next('.sub-menu').slideUp(250);
    	$(this).next('.sub-menu').slideDown(250);
    });
	
    // Collections Page
    $('.product-item-content').click(function() {
	  window.location = $(this).find("a").attr("href"); 
	  return false;
	});

	$('.collection-sidebar .collection-item, .template-product .collection-item').click(function() {
		var dataTag = $(this).data('tag');
		window.location.href = "http://www.nickfraser.co.uk/collections/" + dataTag;
	});
	// Product Page //

	$('.product-info-link').click(function() {
		$('.product-single').addClass('active');
	});
	$('.close, .slideshow-nav').click(function() {
		$('.product-single').removeClass('active');
	});
	$(document).click(function(e) {
		if ( $(e.target).closest('.product-single').length === 0 ) {
			$('.product-single').removeClass('active');
		}
	});

	$(window).load(function() {
			$('.product-description h3').each(function() {
			var tabTitle = $(this).text();
			tabTitle = tabTitle.replace(/\s+/g, '-').replace(/\:/g, '').toLowerCase();
			$(this).addClass('tab-title ' + tabTitle).nextUntil('h3').wrapAll('<div class="tab-content tab-details-'+ tabTitle +'"></div>');
			var $set = $(this).nextUntil("h3").andSelf();
	    	$set.wrapAll('<div class="tab-wrap" />'); 
			});

			$('.tab-title').click(function() {
				$('.tab-title').not(this).addClass('hidden').removeClass('active').next('.tab-content').slideUp(250);
				$(this).addClass('active').removeClass('hidden').next('.tab-content').slideDown(250);
			});
			$('.tab-title.technical, .tab-title.delivery').addClass('hidden');

			$(document).click(function(e) {
			  if ( $(e.target).closest('.tab-title').length === 0 ) {
			    $('.tab-title').not('.tab-title.description').addClass('hidden').removeClass('active').next('.tab-content').slideUp(250);
			  }
			});
		});



	// eof Product Page //

	// Pages w/ bg-img //

	var pageBgImg = $('.image-sidebar-page img:first-of-type').attr('src');
	$('.page-image').css('background-image', 'url(' + pageBgImg + ')');
	$('p > img').unwrap();
	$(window).on('load resize', function() {
		var pageContentHeight = $('.page-content').height();
		$('.page-image').height(pageContentHeight);
	});
	// $(".image-sidebar-page img").each(function(i) {
 //        $(this).addClass("page-img-" + (i+1));
 //    });
$('.image-sidebar-page img:first-of-type').hide();

	// eof Pages w/ bg-img //

});